import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectState } from '@app/core/store/reducers/projects';

const getProjectsFeatureState = createFeatureSelector<ProjectState>('projects');

export const getProjects = createSelector(getProjectsFeatureState, (state: ProjectState) => state.projects);

export const getFilter = createSelector(getProjectsFeatureState, (state: ProjectState) => state.filter);

export const getCurrentProject = createSelector(getProjectsFeatureState, (state: ProjectState) => state.currentProject);

export const getProjectsLoading = createSelector(getProjectsFeatureState, (state: ProjectState) => state.isLoading);

export const getFilteredProjects = createSelector(getProjects, getFilter, (projects, filter) => {
  if (!filter) return projects;
  const search = filter.trim().toLowerCase();
  return (projects ?? []).filter((p) =>
    [p?.id, p?.name, p?.externalId, p?.divisionType]
      .filter((v) => v != null)
      .join(' ')
      .toLowerCase()
      .includes(search),
  );
});

export const getProjectUserReport = createSelector(getProjectsFeatureState, (state) => state.userReport);
export const getProjectUserReportLoading = createSelector(getProjectsFeatureState, (state) => state.userReportLoading);
export const getUserReportFilter = createSelector(getProjectsFeatureState, (state) => state.userReportFilter);

export const getFilteredProjectUserReport = createSelector(
  getProjectUserReport,
  getUserReportFilter,
  (report, filter) => {
    if (!filter) return report;
    const search = filter.trim().toLowerCase();
    return (report ?? []).filter((r) =>
      [r?.projectId, r?.projectName]
        .filter((v) => v != null)
        .join(' ')
        .toLowerCase()
        .includes(search),
    );
  },
);
